/**
 * 区分 priorityType（form_submissions.priority_type）
 * 出典：要件書 5.2
 */
export const PRIORITY_TYPE_VALUES = ['high', 'medium', 'low'] as const;

export type PriorityType = (typeof PRIORITY_TYPE_VALUES)[number];

export const PRIORITY_TYPE_LABELS: Readonly<Record<PriorityType, string>> = {
  high: '高',
  medium: '中',
  low: '低',
};
